import { Subject } from "rxjs";
import { Channel, ChannelPayloadFilter } from "spyne";
import {sendPostMsg} from '@franciscobatista/spyne-plugin-post-msg-tmp';

export class ChannelModalWindow extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_MODAL_WINDOW";
    props.sendCachedPayload = false;

    super(name, props);
  }

  onRegistered() {
    const modalBtnFilter = new ChannelPayloadFilter({
      payload: (p) => p.btnType === "modal",
    });

    this.getChannel("CHANNEL_UI", modalBtnFilter).subscribe(
      this.onModalBtnClicked.bind(this),
    );

    const postMsgFilter = new ChannelPayloadFilter({
      msg: val => val?.type === 'configInfo'
    });

    this.getChannel("CHANNEL_POST_MSG", postMsgFilter)
        .subscribe(this.onPostMsg.bind(this));


    const upgradeSuccessFilter = new ChannelPayloadFilter({
      payload: p => p?.authStateObj?.successValidated === true

    })

    this.getChannel("CHANNEL_APP_ROUTE", upgradeSuccessFilter)
        .subscribe(this.onSuccessUpgradeEvent.bind(this));

  }

  onSuccessUpgradeEvent(e){
    const modalType = 'success';
    const isOpenModal = true;
    const action = "CHANNEL_MODAL_SUCCESS_EVENT";

    const delayByFrame = ()=> this.sendChannelPayload(action, {modalType, isOpenModal})
    requestAnimationFrame(delayByFrame);

  }

  onMessageRequest(e){

    const {payload} = e;
    const modalType = 'message';
    const isOpenModal = true;

    const {iconClass, title, desc} = payload;

    const action = "CHANNEL_MODAL_WINDOW_MESSAGE_EVENT";

    const delayByFrame = ()=> this.sendChannelPayload(action, {modalType, isOpenModal, iconClass, title, desc})
    requestAnimationFrame(delayByFrame);

  }

  onPostMsg(e){
    const {payload, srcElement} = e;
    const {eventType, eventTypeVal} = payload?.msg;
    this.sendModalEvent(eventTypeVal);

   //console.log("POST MSG ",{eventType, eventTypeVal, payload, srcElement, e})

  }

  sendModalEvent(modalType, openModal=true, srcElement={}){
    const isOpenModal = String(openModal) === "true";
    this.sendChannelPayload(
        "CHANNEL_MODAL_WINDOW_CHANGE_EVENT",
        { isOpenModal, openModal, modalType }, srcElement,
    );
  }

  onCloseModalWindowRequest(e){
    const openModal = false;
    const modalType = e.payload?.modalType || 'none';
    const action = "CHANNEL_MODAL_WINDOW_CLOSE_EVENT";
    this.sendChannelPayload(action, {modalType, openModal})


  }

  onModalBtnClicked(e) {
    const { payload, srcElement } = e;

    const { openModal, modalType, modalEventType } = payload;

    const isOpenModal = String(openModal) === "true";


    if (modalEventType === 'tos-accepted'){
       this.onLaunchTOSRequest(true);
    } else {
      this.sendModalEvent(modalType, openModal, srcElement);
    }
  }

  onLaunchTOSRequest(tosApproved = false){
    const isOpenModal = true;
    const modalType = 'tos';
    const action = tosApproved === true ?
        "CHANNEL_MODAL_WINDOW_TOS_APPROVED_EVENT" :
        "CHANNEL_MODAL_WINDOW_LAUNCH_TOS_EVENT"
    this.sendChannelPayload(action, {modalType, isOpenModal});

  }


  addRegisteredActions() {
    return [
      "CHANNEL_MODAL_WINDOW_CHANGE_EVENT",
        "CHANNEL_MODAL_WINDOW_CLOSE_EVENT",
        ["CHANNEL_MODAL_WINDOW_CLOSE_REQUEST_EVENT", "onCloseModalWindowRequest"],
        "CHANNEL_MODAL_WINDOW_MESSAGE_EVENT",
      "CHANNEL_MODAL_WINDOW_MESSAGE_REQUEST_EVENT",
      ["CHANNEL_MODAL_WINDOW_MESSAGE_REQUEST_EVENT", "onMessageRequest"],
      "CHANNEL_MODAL_WINDOW_LAUNCH_TOS_EVENT",
      "CHANNEL_MODAL_WINDOW_TOS_APPROVED_EVENT",
      ["CHANNEL_MODAL_WINDOW_LAUNCH_TOS_REQUEST_EVENT", "onLaunchTOSRequest"],
      "CHANNEL_MODAL_SUCCESS_EVENT"

    ];
  }

  onViewStreamInfo(obj) {
    let data = obj.props();
  }
}
